import {useFormField} from '@/store/form-field';
import {defineStore} from 'pinia';
import LocalStorageDecorator from '@/store/storage/local-storage-decorator';
import {MarkOwnerType} from '@/core/interface/api-interface';
import * as yup from 'yup';
import { validEmail } from '@/core/util/form-validation';
import { useOwnerStore } from './owner';

export interface ContactStore {
    contactEmail: string;
    contactName: string;
}

export const contactNameSchema = yup.string();
export const emailSchema = yup.string()
    .required('Email is required')
    .test('is-valid-email', 'Invalid email address', value => validEmail(value || ''));

export const useContactStore = defineStore('contactStore', () => {
    const ownerStore = useOwnerStore();
    const {value: email, isValid: emailIsValid, error: emailError, validate: emailValidate, reset: emailReset} = useFormField('', emailSchema);
    const {value: names, isValid: namesIsValid, error: namesError, validate: namesValidate, reset: namesReset} = useFormField('', contactNameSchema);

    email.value = ownerStore.email;
    if (ownerStore.ownerType === MarkOwnerType.PERSON) {
        names.value = ownerStore.ownerNames[0];
    }

    function resetData() {
        emailReset();
        namesReset();
    }

    function importData(data: ContactStore) {
        email.value = data.contactEmail;
        names.value = data.contactName;
    }

    function exportData() {
        return {
            contactEmail: email.value,
            contactName: names.value
        };
    }

    const updateContactInformationIfEmpty = () => {
        if (email.value === '') {
            email.value = ownerStore.email;
        }

        if (names.value === '' && ownerStore.ownerType === MarkOwnerType.PERSON) {
            names.value = ownerStore.ownerNames[0];
        }
    }

    const isContactFormValid = () => {
        emailValidate();
        namesValidate();

        return emailIsValid.value
            && namesIsValid.value;
    };

    return {
        email,
        names,
        emailError,
        namesError,
        emailIsValid,
        namesIsValid,
        updateContactInformationIfEmpty,
        isContactFormValid,
        resetData,
        importData,
        exportData
    };
},{
    persist: {
        storage: LocalStorageDecorator
    },
});